import findIndex from 'lodash/findIndex';
import isFunction from 'lodash/isFunction';

const pagerFieldNames = ['count', 'total', 'data', 'links'];

/**
 * Extract the items of a paged data field.
 *
 * @param pagedDataField A field containing data paging information.
 * @returns Array of the data,
 */
export function unpackPagedData(pagedDataField = []) {
  const isPaged =
    Object.keys(pagedDataField).length !== 0 &&
    Object.keys(pagedDataField).reduce(
      (r, item) => r && pagerFieldNames.includes(item),
      true,
    );

  return isPaged ? pagedDataField.data : pagedDataField;
}

// If valueGetter is anything other than a function, it will be added as is rather than run:
export function upsertById(collection, id, valueGetter, opts = {}) {
  const options = { prepend: false, ...opts };
  const index = findIndex(collection, { id });
  const newValue = isFunction(valueGetter)
    ? valueGetter(collection[index], index)
    : valueGetter;

  if (index === -1) {
    return options.prepend
      ? [newValue, ...collection]
      : [...collection, newValue];
  }

  const result = [...collection];
  result[index] = newValue;
  return result;
}

export const getListPageSuccessNewData = (state, data, links) => {
  const startLink = links?.self ?? '';
  const match = startLink.match(/offset=(\d+)/);
  const parsedStartIndex = match && match[1];
  const newData = state.data ? [...state.data] : [];
  const startIndex = parsedStartIndex ? +parsedStartIndex : newData.length;
  data.forEach((d, i) => {
    newData[startIndex + i] = d;
  });
  return newData;
};

export const getListPageSuccessNewLinks = links =>
  Object.keys(links).reduce(
    (obj, link) => ({ ...obj, [link]: decodeURIComponent(links[link]) }),
    {},
  );

export const getListPageSuccessNewDataBQSupport = (state, data, links) => {
  const startLink = links?.self ?? '';
  const match = startLink.match(/offset=(\d+)/);
  const bqMatch = startLink.match(/bqOffset=(\d+)/);
  const parsedStartIndexOffset = match && match[1];
  const parsedStartIndexBQ = bqMatch && bqMatch[1];
  const parsedStartIndex =
    parseInt(parsedStartIndexOffset, 10) + parseInt(parsedStartIndexBQ, 10);
  const newData = state.data ? [...state.data] : [];
  const startIndex = parsedStartIndex ? +parsedStartIndex : newData.length;
  data.forEach((d, i) => {
    newData[startIndex + i] = d;
  });
  return newData;
};
